<a id="focusLogo">Header section</a>
<a id="skipNav" aria-label="Skip to content" href="javascript:void(0)" onclick="skipNav()">Skip navigation</a>
<header class="header hide-acc">
  <div class="container-box" *ngIf="pageContent">
    <div class="row">
      <div class="col-sm-6 col-md-6" *ngIf="tileName">
        <a class="{{pageContent.globalLogo.className}} headerlogo" title="Go to the homepage"
          aria-label="Go to the homepage" href="javascript:void(0);" (click)="navigateToHome()">
          <img *ngIf="pageContent.product == 'fnabc'" src="{{pageContent.globalLogo.imgSrc}}" alt="FirstNet" />
          <i *ngIf="pageContent.product == 'sapmp' || pageContent.product == 'myatt'"
            class="{{pageContent.globalLogo.iClass}}" aria-hidden="true" style="margin-right: 10px !important;"></i>
          <span class="sm-hide" [innerHtml]="pageContent.sideMenu.name"></span>
        </a>
        <div class="hamburger hamburgerDesktop" id="hamNav"> 
          <ul class="nav-mobile">
            <li class="menu-container">
              <input id="menu-toggle" type="checkbox">
              <label for="menu-toggle" class="menu-button">
                <svg class="icon-open" viewBox="0 0 24 24">
                  <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path>
                </svg>
                <svg class="icon-close" viewBox="0 0 100 100">
                  <path
                    d="M83.288 88.13c-2.114 2.112-5.575 2.112-7.69 0L53.66 66.188c-2.113-2.112-5.572-2.112-7.686 0l-21.72 21.72c-2.114 2.113-5.572 2.113-7.687 0l-4.693-4.692c-2.114-2.114-2.114-5.573 0-7.688l21.72-21.72c2.112-2.115 2.112-5.574 0-7.687L11.87 24.4c-2.114-2.113-2.114-5.57 0-7.686l4.842-4.842c2.113-2.114 5.57-2.114 7.686 0l21.72 21.72c2.114 2.113 5.572 2.113 7.688 0l21.72-21.72c2.115-2.114 5.574-2.114 7.688 0l4.695 4.695c2.112 2.113 2.112 5.57-.002 7.686l-21.72 21.72c-2.112 2.114-2.112 5.573 0 7.686L88.13 75.6c2.112 2.11 2.112 5.572 0 7.687l-4.842 4.84z" />
                </svg>
              </label>
              <ul class="menu-sidebar">
                <li class="has-subnav" [ngClass]="{'active': homeRouteActive('/home')}">
                  <a routerLinkActive="active" routerLink="{{pageContent.sideMenu?.list[0]?.routerLink}}"
                    (click)="commonFunction(pageContent.sideMenu?.list[0]?.function,pageContent.sideMenu?.list[0]?.parameter)">
                    <i class="fa fa-2x"> <img src="{{pageContent.sideMenu?.list[0]?.image}}"
                        style="Width:26px; height: 26px;"></i>
                    <span class="nav-text">
                      {{pageContent.sideMenu.list[0].content}}
                    </span>
                  </a>
                </li>
                <li *ngIf="showRegisterIcon" class="has-subnav listmargin" [ngClass]="{'active': enrollRouteActive()}">
                  <a routerLinkActive="active"
                    (click)="commonFunction(pageContent.sideMenu?.list[1]?.function,pageContent.sideMenu?.list[1]?.parameter);">
                    <i class="fa fa-2x"> <img src="{{pageContent.sideMenu?.list[1]?.image}}"
                        style="Width:26px; height: 26px;"></i>
                    <span class="nav-text">
                      {{pageContent.sideMenu?.list[1]?.content}}
                    </span>
                  </a>

                </li>
                <li class="has-subnav listmargin" [ngClass]="{'active': homeRouteActive('/manageInventory')}">
                  <a routerLink="{{pageContent.sideMenu?.list[2]?.routerLink}}" routerLinkActive="active"
                    (click)="commonFunction(pageContent.sideMenu?.list[2]?.function,pageContent.sideMenu?.list[2]?.parameter)">
                    <i class="fa fa-2x"> <img src="{{pageContent.sideMenu?.list[2]?.image}}"
                        style="Width:30px; height: 30px;"></i>
                    <span class="nav-text">
                      {{pageContent.sideMenu?.list[2]?.content}}
                    </span>
                  </a>
                </li>
                <!-- Forcing route active to return false as per US-1367 -->
                <li *ngIf="false" class="has-subnav listmargin" [ngClass]="{'active': learnRouteActive()}">
                  <a routerLink="{{pageContent.sideMenu.list[3].routerLink}}" routerLinkActive="active" class="fortab"
                    (click)="commonFunction(pageContent.sideMenu?.list[3]?.function,pageContent.sideMenu?.list[3]?.parameter);learnRouteActive()">
                    <i class="fa fa-2x"> <img src="{{pageContent.sideMenu?.list[3]?.image}}"
                        style="Width:30px; height: 30px;"></i>
                    <span class="nav-text">
                      {{pageContent.sideMenu?.list[3]?.content}}
                    </span>
                  </a>
                  <span>
                    <img [style.display]="openDropMenu ? '' : 'none'" id='show' class="dropdownMenu"
                      style="padding: 5px; width: 23px;" src="assets/img/dropdownMenu.png"
                      alt="image icon for openDropMenu" (click)="openCloseSubMenu('show');" />
                    <img [style.display]="closeDropMenu ? '' : 'none'" id='hide' class="dropdownMenu"
                      style="padding: 5px; width: 23px;" src="assets/img/closeDropDown.png"
                      alt="image icon for closeDropDown" (click)="openCloseSubMenu('hide');" />
                  </span>
                </li>
                <ul class="fa fa-2x" *ngIf="false && display">
                  <li class="has-subnav" style="height: 30px; margin-left: 45px; margin-top: -10px;">
                    <a (click)="checkSlider(pageContent.sideMenu.list[3].subMenu[0].routerLink,pageContent.sideMenu.list[3].subMenu[0].content)"
                      routerLinkActive="active">
                      <i class="fa fa-2x"></i>
                      <span class="nav-text text learnItems">
                        {{pageContent.sideMenu?.list[3]?.subMenu[0]?.content}}
                      </span>
                    </a>
                  </li>
                  <li class="has-subnav" style="height: 30px; margin-left: 45px">
                    <a (click)="checkSlider(pageContent.sideMenu?.list[3]?.subMenu[1]?.routerLink,pageContent.sideMenu?.list[3]?.subMenu[1]?.content)"
                      routerLinkActive="active">
                      <i class="fa fa-2x"></i>
                      <span class="nav-text text learnItems">
                        {{pageContent.sideMenu?.list[3]?.subMenu[1]?.content}}
                      </span>
                    </a>
                  </li>
                  <li class="has-subnav"
                    style="margin-left: 45px; text-align: initial; height: 30px; margin-bottom: 10px;">
                    <a (click)="checkSlider(pageContent.sideMenu?.list[3]?.subMenu[2]?.routerLink,pageContent.sideMenu?.list[3]?.subMenu[2]?.content)"
                      routerLinkActive="active">
                      <i class="fa fa-2x"></i>
                      <span class="nav-text text learnItems">
                        {{pageContent.sideMenu?.list[3]?.subMenu[2]?.content}}
                      </span>
                    </a>
                  </li>
                  
                </ul>
                <li class="has-subnav listmargin" [ngClass]="{'active': homeRouteActive('/faq')}">
                  <a routerLink="{{pageContent.sideMenu.list[4].routerLink}}" routerLinkActive="active"
                    (click)="commonFunction(pageContent.sideMenu?.list[4]?.function,pageContent.sideMenu?.list[4]?.parameter)">
                    <i class="fa fa-2x"> <img src="{{pageContent.sideMenu?.list[4]?.image}}"
                        style="Width:26px; height: 26px;"></i>
                    <span class="nav-text">
                      {{pageContent.sideMenu?.list[4]?.content}}
                    </span>
                  </a>
                </li>
                <li class="has-subnav listmargin" [ngClass]="{'active': homeRouteActive('/support')}">
                  <a routerLink="{{pageContent.sideMenu.list[5].routerLink}}" routerLinkActive="active"
                    (click)="commonFunction(pageContent.sideMenu?.list[5]?.function,pageContent.sideMenu?.list[5]?.parameter)">
                    <i class="fa fa-2x"> <img src="{{pageContent.sideMenu?.list[5]?.image}}"
                        style="Width:26px; height: 26px;"></i>
                    <span class="nav-text">
                      {{pageContent.sideMenu?.list[5]?.content}}
                    </span>
                  </a>
                </li>
                <hr style="border-top: 2px solid whitesmoke; margin-bottom: 3px;">
                <li class="has-subnav listmargin">
                  <a href="{{pageContent.sideMenu.list[7].href}}"
                    (click)="commonFunction(pageContent.sideMenu?.list[7]?.function,pageContent.sideMenu?.list[7]?.parameter)">
                    <i class="fa fa-2x">
                      <img src="{{pageContent.sideMenu?.list[7]?.image}}" style="Width:26px; height: 26px;"></i>
                    <span class="nav-text">
                      {{pageContent.sideMenu?.list[7]?.content}}
                    </span>
                  </a>
                </li>
                <li class="has-subnav listmargin">
                  <a href="{{pageContent.sideMenu.list[8].href}}"
                    (click)="commonFunction(pageContent.sideMenu?.list[8]?.function,pageContent.sideMenu?.list[8]?.parameter)">
                    <i class="fa fa-2x"> <img *ngIf="pageContent.sideMenu?.list[8]?.image"
                        src="{{pageContent.sideMenu?.list[8]?.image}}" style="Width:26px; height: 26px;"></i>
                    <span class="nav-text">
                      {{pageContent.sideMenu?.list[8]?.content}}
                    </span>
                  </a>
                </li>
                <li class="has-subnav listmargin">
                  <span class="last-login-info" *ngIf="!lastLoginTime"></span>
                  <span class="last-login-time" *ngIf="lastLoginTime">Last Login: {{lastLoginTime}}</span>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <!--Admin Portal start-->
      <div class="col-sm-6 col-md-6" *ngIf="!tileName">
        <a class="{{pageContent.globalLogo.className}}" title="Go to the homepage" aria-label="Go to the homepage"
          href="/businessconsole/home">
          <img *ngIf="pageContent.product == 'fnabc'" src="{{pageContent.globalLogo.imgSrc}}" alt="FirstNet" />
          <i *ngIf="pageContent.product == 'sapmp' || pageContent.product == 'myatt'"
            class="{{pageContent.globalLogo.iClass}}" aria-hidden="true"></i>
        </a>
        <div class="hamburger" id="hamNav">
          <a #hamNav href="javascript:void(0)" (click)="toggleMenu(hamNav)" class="menu-btn"
            aria-label="pageContent.menu.name" aria-controls="main-menu">
            <i class="icon-hamburger line-icon" aria-label="Open the menu." alt="Open the menu" title="Open the menu"
              role="img"></i>
            <i class="icon-close close-icon" aria-label="Close the menu." alt="Close the menu" title="Close the menu"
              role="img"></i>
            <span class="sm-hide" [innerHtml]="pageContent.menu.name"></span>
          </a>
          <div class="main-menu" id="main-menu">
            <a href="javascript:void(0)" aria-label="Close" class="close-btn" (click)="hideMenu()">
              <i class="icon-close" aria-hidden="true"></i>
            </a>
            <ul id="header-dropdown">
              <li *ngFor="let content of pageContent.menu.list">
                <a *ngIf="content.routerLink!='manageAbc' && content.routerLink!='separator' && !(content.routerLink || content.href)"
                  routerLinkActive="active"
                  (click)="commonFunction(content.function,content.parameter)">{{content.content}}</a>
                <a *ngIf="content.routerLink!='manageAbc' && content.routerLink!='separator' && (content.routerLink)"
                  [routerLink]="content.routerLink" routerLinkActive="active"
                  (click)="commonFunction(content.function,content.parameter)">{{content.content}}</a>
                <a *ngIf="content.routerLink!='manageAbc' && content.routerLink!='separator' && (content.href)"
                  [href]="content.href"
                  (click)="commonFunction(content.function,content.parameter)">{{content.content}}</a>

                <div *ngIf="content.routerLink=='separator'" class="menu-seperator"></div>

                <a *ngIf="content.routerLink=='manageAbc'" id="sub-menu" (click)="toggleSubMenu()"
                  href="javascript:void(0);" attr.aria-label="Open the submenu {{content.content}}."
                  aria-expanded="false" role="menu">{{content.content}}
                  <i class="icon-right nav-right-icon"></i>
                </a>
                <ul *ngIf="content.routerLink=='manageAbc'" class="sub-dropdown">
                  <li role="menuitem" class="lg-hide">
                    <a (click)="toggleSubMenu()" href="javascript:void(0);" class="back-button" role="button"
                      aria-label="Return to previous menu.">
                      <i class="icon-left nav-left-icon" role="img"></i> Back</a>
                  </li>
                  <li class="lg-hide menu-subtitle">{{content.content}}</li>
                  <li class="menu-seperator lg-hide"></li>
                  <li *ngFor="let sub of content.subMenu">
                    <a [routerLink]="sub.routerLink" [href]="sub.href" routerLinkActive="active"
                      (click)="commonFunction(sub.function,sub.parameter)">{{sub.content}}</a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!--Admin portal End-->
      <div class="col-sm-6 col-md-6 text-right user-info pull-right">
        <span class="hide-mobile-view">
          <span class="last-login-info" *ngIf="!lastLoginTime"></span>        
          <span class="last-login-time" *ngIf="lastLoginTime">Last Login: {{lastLoginTime}}</span>
        </span>
        <span class="user-profile" id="userProfileInfo">
          <!-- DEMO/POC CODE REMOVE 
       [style.background]="user?.userId ? 'yellow' : 'green' " 
        -->

          <!--  BEGIN SPINNER TEST-->
          <img *ngIf="isLoggingIn" src="assets/img/spinner.svg" width="25px" />
          <!--  BEGIN SPINNER TEST-->

          <div class="{{pageContent.loginlogout.profileClass}}">
            <span style="display:none;" class="{{pageContent.loginlogout.firstNameClass}}"></span>

            <!-- <a href="javascript:void(0);" *ngIf="isAdminLoggedIn" id="TaskTrigger" class="loginBtn" (click)="commonLoginDropdown(this)"
              [attr.aria-label]="pageContent.loginlogout.loginBtnClass.screenReader" style="display:inline">
              <span class="{{pageContent.loginlogout.logIn.class}}">Request Support</span>
            </a> -->
            <a id="loginBtn1" *ngIf="pageContent.loginDropdownPopup == 'true'" class="loginBtn" (click)="commonLoginDropdown(this)"
              [attr.aria-label]="pageContent.loginlogout.loginBtnClass.screenReader" style="display:inline">
              <i class="{{pageContent.loginlogout.onePerson.class}}" aria-hidden="true" role="img"></i>
              <span class="{{pageContent.loginlogout.logIn.class}}">{{pageContent.loginlogout.logIn.content}}</span>
            </a>

            <a id="loginBtn2" *ngIf="pageContent.loginDropdownPopup == 'false'" class="loginBtn"
              [attr.aria-label]="pageContent.loginlogout.loginBtnClass.screenReader" style="display:none"
              href="javascript:void(0);" (click)="loginFnDirect()">
              <i class="{{pageContent.loginlogout.onePerson.class}}" aria-hidden="true" role="img"></i>
              <span class="{{pageContent.loginlogout.logIn.class}}">{{pageContent.loginlogout.logIn.content}}</span>
            </a>
            <a #alertnav1 *ngIf="pageContent.product == 'sapmp'" class="logoutBtn menu-btn" href="javascript:void(0)"
              (click)="toggleAlertMenu(alertnav1)" id="alert-nav">
              <i aria-label="Log out" title="Log out" class="icon-people-oneperson" id="icon-log-out" role="img"></i>
              <i aria-label="Close Log out" title="Close Log out" class="icon-close close-icon" id="icon-close-log-out"
                role="img"></i>
              <span class="user-alerts" id="alert-widget"></span>
              <span class="sm-hide log-out-text">Log out</span>
            </a>

            <a #alertnav2 *ngIf="pageContent.product == 'fnabc'" class="logoutBtn menu-btn" href="javascript:void(0)"
              (click)="toggleAlertMenu(alertnav2)" id="alert-nav">
              <i aria-label="Log out" title="Log out" class="icon-people-oneperson" id="icon-log-out" role="img"></i>
              <i aria-label="Close Log out" title="Close Log out" class="icon-close close-icon" id="icon-close-log-out"
                role="img"></i>
              <span class="user-alerts" id="alert-widget"></span>
              <span class="sm-hide log-out-text">Log out</span>
            </a>

            <a #alertnav3 *ngIf="pageContent.product == 'myatt'" class="logoutBtn menu-btn" href="javascript:void(0)"
              (click)="toggleAlertMenu(alertnav3)" id="alert-nav">
              <i aria-label="Log out " title="Log out" class="icon-people-oneperson" id="icon-log-out" role="img"></i>
              <i aria-label="Close Log out" title="Close Log out" class="icon-close close-icon" id="icon-close-log-out"
                role="img"></i>
              <span class="user-alerts" id="alert-widget"></span>
              <span class="sm-hide log-out-text">Log out</span>
            </a>

          </div>
          <div class="login-container">
            <a href="javascript:void(0)" class="close-btn" (click)="hideNotification()"><i class="icon-close" role="img"
                aria-label="Close AT&T Business Console."></i></a>
            <div class="notification-box">
              <div class="login-dropdown main-menu">
                <ul>
                  <li>
                    <p class="user-name" tabindex="0"> Hello, <span class="first-name"></span> </p>
                  </li>
                  <li class="clearfix"></li>
                  <li><button id="newLogoutBtn" #logoutBtn class="btn btn-default" aria-label="Log out." (click)="logoutUser({isConfirmPopup: false})">Log
                      out</button></li>
                      <!-- <li><button id="newLogoutBtn" #logoutBtn class="btn btn-default" aria-label="Log out." onclick="logoutCurrentUser(false)">Log
                        out</button></li> -->
                  <li>
                    <!-- alert component will be bootstrapped here -->
                    <div id="alert-container" class="alert-container">
                      <app-parent *ngIf="user?.userId">
                        <app-notifications></app-notifications>
                      </app-parent>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="common-login-container" id="common-login-container">
            <div class="loginModal-box" id="loginModal-box">
              <div class="login-dropdown">
                <ul>
                  <li class="heading">Select your AT&T Service </li>
                  <li><a style="width:100%" (click)="loginDirect('sapmp')"><span class="subHeading">Premier</span><br>
                      <span class="content">Access your organizations's account, devices and services.</span></a></li>
                  <li><a style="width:100%" (click)="loginDirect('fnabc')"><span class="subHeading">FirstNet
                        Central</span><br>
                      <span class="content">Manage your FirstNet devices and services.</span></a></li>
                  <li><a style="width:100%" (click)="loginDirect('myatt')"><span class="subHeading">myAT&T for
                        Business</span><br>
                      <span class="content">Manage your small business devices and services.</span></a></li>
                </ul>
              </div>
            </div>
          </div>
        </span>
      </div>
    </div>
  </div>
</header>